module.exports = __webpack_public_path__ + "img/1.0281c40e.png";